import { render, staticRenderFns } from "./NovaCotacaoDialog.vue?vue&type=template&id=03e8d592&scoped=true"
import script from "./NovaCotacaoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NovaCotacaoDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NovaCotacaoDialog.vue?vue&type=style&index=0&id=03e8d592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e8d592",
  null
  
)

export default component.exports